import { GlobalStyles, useTheme } from "@mui/material";

const CalendarGlobalStyles = () => {
  const theme = useTheme();
  return (
    <GlobalStyles
      styles={{
        // Хедър и колони
        ".fc-col-header-cell": {
          backgroundColor: theme.palette.primary.light,
          color: "#fff",
          textTransform: "uppercase",
          fontWeight: "100",
        },
        ".fc-col-header-cell.fc-day": {
          padding: "8px",
        },
        ".fc-timegrid-slot-label": {
          backgroundColor: theme.palette.primary.light,
          color: "#fff",
        },
        ".fc-timegrid-axis": {
          backgroundColor: theme.palette.primary.light,
        },

        ".fc-day.fc-day-wed.fc-day-today.fc-timegrid-col": {
          backgroundColor: "#f0f0f0",
        },
        // Еvent стилове
        ".fc-event": {
          fontSize: "0.75rem",
          lineHeight: 1.3,
          overflowY: "auto",
          maxHeight: "100%",
          backgroundColor: theme.palette.warning.light,
          color: "black",
          border: `1px solid ${theme.palette.primary.light}`,
          borderRadius: "4px",
        },
        ".fc-event::-webkit-scrollbar": {
          width: "4px",
          height: "4px",
        },
        ".fc-event::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(0,0,0,0.3)",
          borderRadius: "2px",
        },
        // Вътрешни елементи
        ".fc-event .discipline-label": {
          color: theme.palette.primary.main,
        },
        ".fc-event .discipline-value": {
          color: theme.palette.error.main,
          fontWeight: "bold",
        },
        ".title": {
          color: theme.palette.primary.main,
        },
        ".value": {
          color: theme.palette.error.main,
        },
      }}
    />
  );
};
export default CalendarGlobalStyles;
